import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ApiError from "lib/ApiError";
import CapacityLeadBasicInformationTable from "./CapacityLeadBasicInformationTable";
import CapacityLeadProductCriteriaInformationTable from "./CapacityLeadProductCriteriaInformationTable";
import { Promotion } from "features/registrationRequest";
import { BackToTopButton } from "components/ui/buttons";
import { useGetCapacityLeadById } from "../service/CapacityLeadService";
import { getCommaSeparatedPhoneNumberFromArray } from "lib/leadNumber/phoneNumber";
import { isRegistrationForAm } from "constants/index";
import { LeadType } from "types/leadType";

// Dummy-Komponente für Aktivitäten (Mails, Anrufe, Kommentare etc.)
const LeadActivities = () => {
  return (
    <div className="lead-activities">
      <h2>Aktivitäten</h2>
      <ul>
        <li>Email an Klient am 24.03.2025</li>
        <li>Anruf am 23.03.2025</li>
        <li>Kommentar: "Rückruf gewünscht" am 22.03.2025</li>
      </ul>
    </div>
  );
};

// Dummy-Komponente für Verlinkungen zum Klienten (z. B. weitere Kontakte, Dokumente etc.)
const ClientLinks = () => {
  return (
    <div className="client-links">
      <h2>Klienten-Verlinkungen</h2>
      <ul>
        <li><a href="#kontaktverlauf">Kontaktverlauf</a></li>
        <li><a href="#dokumente">Dokumente</a></li>
        <li><a href="#termine">Bevorstehende Termine</a></li>
      </ul>
    </div>
  );
};

function CapacityLeadOverview() {
  const { secureId } = useParams() as { secureId: string };
  const { data: capacityLeadDetailsInfo } = useGetCapacityLeadById(secureId);

  const [isRegisterForAMSet, setIsRegisterForAMSet] = useState(false);
  const [PromotionModalOpen, setPromotionModal] = useState<boolean>(false);

  function showPromotionModal() {
    setPromotionModal(true);
  }

  function onSuccess() {
    setIsRegisterForAMSet(true);
    localStorage.setItem(isRegistrationForAm, "true");
  }

  function onError() {
    localStorage.setItem(isRegistrationForAm, "false");
    setIsRegisterForAMSet(false);
  }

  return (
    <div className="lead-container">
      {capacityLeadDetailsInfo && (
        <Promotion
          secureId={capacityLeadDetailsInfo?.secureId}
          leadType={LeadType.Capacity}
          requestNumber={capacityLeadDetailsInfo?.capacityLeadNumber}
          productName={capacityLeadDetailsInfo?.productName}
          promotionModalOpen={PromotionModalOpen}
          setPromotionModal={setPromotionModal}
          onEmailSend={() => onSuccess()}
          onEmailError={() => onError()}
        />
      )}
      <BackToTopButton />
      <div className="waiting-list-lead-nav-box">
        <a className="link-pointer pull-right" onClick={showPromotionModal}>
          Jetzt digital Kunden gewinnen
        </a>
      </div>
      <h1 className="text-blue">
        Anfrage: {capacityLeadDetailsInfo?.capacityLeadNumber}
      </h1>
      <div className="flex-nowrap align-center">
        <h3 className="highlight-green">
          <span className="icons-crown overview-icon"></span>{" "}
          <span className="capacity-message">
            Sie haben diese Anfrage erfolgreich erworben.
          </span>
        </h3>
      </div>

      {/* Layout mit zwei Sidebars und einem zentralen Bereich */}
      <div className="hubspot-layout">
        {/* Linke Sidebar: Details zum Klienten und Produkt */}
        <aside className="sidebar sidebar-left">
          {capacityLeadDetailsInfo && (
            <>
              <CapacityLeadBasicInformationTable
                firstName={capacityLeadDetailsInfo.firstName}
                lastName={capacityLeadDetailsInfo.lastName}
                productName={capacityLeadDetailsInfo.productName}
                clientAvailability={capacityLeadDetailsInfo.clientAvailability}
                capacityLeadState={capacityLeadDetailsInfo.capacityLeadState}
                requestRegion={capacityLeadDetailsInfo.requestRegion}
                requestZipCode={capacityLeadDetailsInfo.requestZipCode}
                phoneNumber={getCommaSeparatedPhoneNumberFromArray(
                  capacityLeadDetailsInfo.phoneNumbers
                )}
              />
              <CapacityLeadProductCriteriaInformationTable
                capacityLeadProductCriteriaInfo={{
                  capcityLeadState: capacityLeadDetailsInfo.capacityLeadState,
                  productCriteriaList:
                    capacityLeadDetailsInfo.productCriteriaList,
                }}
              />
            </>
          )}
        </aside>

        {/* Zentrale Inhalte: Aktivitäten zu dem Lead */}
        <main className="main-content">
          <LeadActivities />
        </main>

        {/* Rechte Sidebar: Verlinkungen zu dem Klienten */}
        <aside className="sidebar sidebar-right">
          <ClientLinks />
        </aside>
      </div>
    </div>
  );
}

export default CapacityLeadOverview;
